import React, { Component } from 'react'
import { connect } from 'react-redux';
import classes from './VideoPlayerControls.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import * as actions from 'store/actions/index';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCut } from '@fortawesome/free-solid-svg-icons';
import { injectIntl } from 'react-intl';
import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as Controls from 'Flow2/config/Controls';
import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import Swal from 'sweetalert2';

class Cut extends Component {
	
	constructor(props) {
		super(props);
		this.state = { ...this.initState(props) }
	};

	initState = (props) => {
		const state = {}
		
		return state;
	}

	componentWillReceiveProps = (nextProps) => {
		if(!Object.is(this.props.video, nextProps.video)) {
			nextProps.video.addEventListener('timeupdate', this.onTimeUpdate);
		}
		
		/*if (nextProps.cutting) {
			Swal.fire({
				title: this.props.intl.formatMessage({ id: "popup.title.cut.clip" }),
				text: this.props.intl.formatMessage({ id: "popup.message.cut.clip.started" }),
				showCancelButton: false,
				confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
				confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
				buttonsStyling: false
			});
		}*/
		
		if (this.props.clip.id !== nextProps.clip.id) {
			const state = { ...this.state, ...this.initState(nextProps) }
			this.setState({ ...state });
		}
	}
	
	onTimeUpdate = (evt) => {
        this.props.setTimeLineLength(evt.target.currentTime / evt.target.duration * 100);
	}

	onCutHandler = () => {
		if (this.state.leftMarkerTimeframe === null || this.state.rightMarkerTimeframe === null) {
			Swal.fire({
				title: this.props.intl.formatMessage({ id: "popup.title.cut" }),
				text: this.props.intl.formatMessage({ id: "popup.message.cut.marker" }),
				confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
				confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
				buttonsStyling: false
			});
		} else {
			let cutArguments = {
				"newtitle": this.props.clip.metadata.title + ` (Sec: ${Math.round(this.props.leftMarkerSeconds)} - ${Math.round(this.props.rightMarkerSeconds)})`/* "testheli.mp4 (sec: 1 - 2)"*/,
				"batch": 4,
				"preset": "51",
				"sources": [{ "clid": this.props.clip.id, "fframe": this.props.leftMarkerTimeframe, "lframe": this.props.rightMarkerTimeframe/*, "mfid": this.props.clip.mainmediafile.id*/ }]
			}

			this.props.cutClip(this.props.clip.id, cutArguments.newtitle, cutArguments.batch, cutArguments.preset, cutArguments.sources);
			console.log(cutArguments);
            
            Swal.fire({
				title: this.props.intl.formatMessage({ id: "popup.title.cut.clip" }),
				text: this.props.intl.formatMessage({ id: "popup.message.cut.clip.started" }),
				showCancelButton: false,
				confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
				confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
				buttonsStyling: false
			});
		}

	}

	componentDidMount() {
        this.props.resetCut();
	}
	
	allowCut = () => {
        if(PH.hasPermission({ user: this.props.user, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP })) {
            return true;
        }
        
        return PH.hasFieldPermission({ user: this.props.user, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "cut");
    }
	
	renderSetLeftMarker = () => {
		if(!this.allowCut() || !PH.showControl(this.props.config, Controls.CTL_PLAYER_CUT)) return "";
		
		const setLeftMarker = (evt) => {
            const data = {
                leftMarkerPosition: this.props.timeLineLength,
				leftMarkerTimeframe: this.props.video.currentTime,//Math.floor(this.props.video.currentTime * this.props.mediafile.fps),
				leftMarkerSeconds: this.props.video.currentTime
            };
            
            this.props.setLeftMarker(data);
            
            if(data.leftMarkerPosition > this.props.rightMarkerPosition) {
                this.props.setRightMarker({
                    rightMarkerPosition: 100,
                    rightMarkerTimeframe: null,
                    rightMarkerSeconds: null
                });
            }
		}
		
		return (
			<div className={[classes.CutLeft, 'pointer'].join(' ')} onClick={setLeftMarker} title={this.props.intl.formatMessage({ id: "videoplayer.leftmarker.click" })} ></div>
		);
	}
	
	renderSetRightMarker = () => {
		if(!this.allowCut() || !PH.showControl(this.props.config, Controls.CTL_PLAYER_CUT)) return "";
		
		const setRightMarker = (evt) => {
			if (this.props.leftMarkerTimeframe === null) return;
			
			const data = {
                rightMarkerPosition: this.props.timeLineLength,
				rightMarkerTimeframe: this.props.video.currentTime,//Math.floor(this.props.video.currentTime * this.props.mediafile.fps),
				rightMarkerSeconds: this.props.video.currentTime
            };
            
            this.props.setRightMarker(data);
            
            if(data.rightMarkerPosition < this.props.leftMarkerPosition) {
                this.props.setLeftMarker({
                    leftMarkerPosition: 0,
                    leftMarkerTimeframe: null,
                    leftMarkerSeconds: null
                });
            }
		}
		
		return (
			<div className={[classes.CutRight, 'pointer'].join(' ')} onClick={setRightMarker} title={this.props.intl.formatMessage({ id: "videoplayer.rightmarker.click" })} ></div>		
		);
	}
	
	renderCut = () => {
		if(!this.allowCut() || !PH.showControl(this.props.config, Controls.CTL_PLAYER_CUT)) return "";
		
		const onCut = () => {
			if (this.props.onCutHandler) {
				this.props.onCutHandler(this.props, this.props.clip, this.props.leftMarkerTimeframe, this.props.rightMarkerTimeframe);
			} else {
				this.onCutHandler();
			}
		}
		
		return (
			<div className={[classes.Cut, classes.Icon, 'pointer'].join(' ')} >
				<FontAwesomeIcon onClick={onCut} icon={faCut} color="" title={this.props.intl.formatMessage({ id: "videoplayer.cut.start" })} />
			</div>
		);
	}

	render = () => {
		return (
			<FlexRow>
				{ this.renderSetLeftMarker() }
				{ this.renderSetRightMarker() }
				{ this.renderCut() }
			</FlexRow>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		cutting: state.clip.cutting,
		config: state.ui.config,
		timeLineLength: state.cut.timeLineLength,
        leftMarkerPosition: state.cut.leftMarkerPosition,
        leftMarkerTimeframe: state.cut.leftMarkerTimeframe,
        leftMarkerSeconds: state.cut.leftMarkerSeconds,
        rightMarkerPosition: state.cut.rightMarkerPosition,
        rightMarkerTimeframe: state.cut.rightMarkerTimeframe,
        rightMarkerSeconds: state.cut.rightMarkerSeconds
	}
}


const mapDispatchToProps = (dispatch) => {
	return {
		cutClip: (clip, newtitle, batch, preset, source, add) => dispatch(actions.cutClip(clip, newtitle, batch, preset, source, add)),
		setTimeLineLength: (length) => dispatch(actions.setTimeLineLength(length)),
		setLeftMarker: (data) => dispatch(actions.setLeftMarker(data)),
		setRightMarker: (data) => dispatch(actions.setRightMarker(data)),
		resetCut: () => dispatch(actions.resetCut())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Cut));

const timeLine = (props) => {
    if(!PH.showControl(props.config, Controls.CTL_PLAYER_CUT)) return "";
		
    const showRange = props.leftMarkerTimeframe != null && props.rightMarkerTimeframe != null;
    const leftActive = props.leftMarkerTimeframe != null;
    const rightActive = props.rightMarkerTimeframe != null;
    
    return (
        <div className={classes.TimeLine}>
            <div className={classes.CutProgress} style={{ width: props.timeLineLength + '%' }} ></div>
            <div
                className={[classes.CutRange, showRange].join(' ')}
                style={{ left: props.leftMarkerPosition + '%', right: 'calc(' + (100 - props.rightMarkerPosition) + '%)' }}
                title={'Cut Range'} >
            </div>
            <div
                className={[classes.CutMarkerLeft, leftActive].join(' ')}
                style={{ left: 'calc(' + props.leftMarkerPosition + '% - 10px)' }}
                title={(props.leftMarkerSeconds !== null && (props.leftMarkerSeconds + " seconds")) || 'Not set'} >
            </div>
            <div
                className={[classes.CutMarkerRight, rightActive].join(' ')}
                style={{ left: props.rightMarkerPosition + '%' }}
                title={(props.righttMarkerSeconds !== null && (props.rightMarkerSeconds + " seconds")) || 'Not set'} >
            </div>
        </div>
    );
}

export const CutTimeLine = connect(mapStateToProps)(injectIntl(timeLine));
